import App from './App.svelte';
const app = new App({
	target: document.body,
	props: {
		name: 'Source Code Viewer'
	}
});

export default app;